import DashCensoEscolar from "@/Pages/CensoEscolar/index.vue";
import ShowCensoEscolar from "@/Pages/CensoEscolar/ShowCensoEscolarPage.vue";
import ShowEtapa from "@/Pages/CensoEscolar/ShowEtapaPage.vue";
import PreenchimentoCenso from "@/Pages/CensoEscolar/PreenchimentoCensoPage.vue";
import somenteAdminCenso from "./guards/somenteAdminCenso";

export default [
  {
    path: "/censo-escolar/",
    name: "censo-escolar",
    component: DashCensoEscolar,
    beforeEnter: somenteAdminCenso,
  },
  {
    path: "/censo-escolar/preenchimento",
    name: "censo-escolar.preenchimento",
    component: PreenchimentoCenso,
    beforeEnter: somenteAdminCenso,
  },
  {
    path: "/censo-escolar/:id",
    name: "censo-escolar-show",
    component: ShowCensoEscolar,
    beforeEnter: somenteAdminCenso,
  },
  {
    path: "/censo-escolar/:id/etapas/:etapaId",
    name: "censo-escolar-etapa",
    component: ShowEtapa,
    beforeEnter: somenteAdminCenso,
  },
];
